import { TissueTestAPI, SoilTestAPI, WaterTestAPI, MediaAnalysisAPI } from '@/api';

import tissue from './tissue.store'

export default {
  namespaced: true,
  state: {

    data: [],
    haveSoilTests: false,
    haveWaterTests: false,
    haveTissueTests: false,
    haveMediaAnalysis: false,
    filters: {
      take: 1000,
      page: 0,
      type: 'soil-anal',
      search: '',
    }
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    clearData(state) {
      state.data = [];
    },
    setType(state, type) {
      state.filters.type = type;
    },
    setSearch (state, val) {
      state.filters.search = val;
    },
    setSoil(state, value) {
      state.haveSoilTests = value;
    },
    setWater(state, value) {
      state.haveWaterTests = value;
    },
    setTissue(state, value) {
      state.haveTissueTests = value;
    },
    setMedia(state, value) {
      state.haveMediaAnalysis = value;
    },
  },
  actions: {

    checkIfHaveTests({commit, state}) {

        WaterTestAPI.getAllAnalysis(state.filters).then(res => {
          if(res.data.length) {
            commit('setWater', true);
          } else {
            commit('setWater', false);
          }
        });

        SoilTestAPI.select(state.filters).then(res => {
          if(res.data.length) {
            commit('setSoil', true);
          } else {
            commit('setSoil', false);
          }
        });

        TissueTestAPI.getAllAnalysis(state.filters).then(res => {
          if(res.data.length) {
            commit('setTissue', true);
          } else {
            commit('setTissue', false);
          }
        });
        MediaAnalysisAPI.select(state.filters).then(res => {
          if(res.data.length) {
            commit('setMedia', true);
          } else {
            commit('setMedia', false);
          }
        });

    },
    //=================================================================================
    updateData({ commit, state }) {

      const type = state.filters.type;
      // commit('clearData');

      if(type == 'water-anal') {
        return WaterTestAPI.getAllAnalysis(state.filters)
        .then(res => {
          let result = JSON.parse(JSON.stringify(res));

          if (result.data.message == "Please buy a plan!") {
            throw new Error("Please buy a plan")
          } 
          
          else {

          console.log(res.data.data)
          commit('setData', res.data.data);
          if(res.data.length) {
            commit('setWater', true);
          } else {
            commit('setWater', false);

          }
        }
        });
      }
      //TODO: поменять рут и коммиты
      if(type == 'media-anal') {
        return MediaAnalysisAPI.select(state.filters).then(res => {

          let result = JSON.parse(JSON.stringify(res));

          if (result.data.message == "Please buy a plan!") {
            throw new Error("Please buy a plan")
          } 
          
          else {


          console.log(res.data)
          commit('setData', res.data);
          if(res.data.length) {
            commit('setMedia', true);
          } else {
            commit('setMedia', false);
          }
        }
        });
      }
      else if(type == 'soil-anal') {
        return SoilTestAPI.select(state.filters).then(res => {

          let result = JSON.parse(JSON.stringify(res));

          if (result.data.message == "Please buy a plan!") {
            throw new Error("Please buy a plan")
          } 
          
          else {


          console.log(res.data)
          commit('setData', res.data);
          if(res.data.length) {
            commit('setSoil', true);
          } else {
            commit('setSoil', false);
          }
        }
        });
      }
      else if(type == 'tissue-anal') {
        return TissueTestAPI.getAllAnalysis(state.filters).then(res => {

          let result = JSON.parse(JSON.stringify(res));

          if (result.data.message == "Please buy a plan!") {
            throw new Error("Please buy a plan")
          } 
          
          else {


          console.log(res.data);
          commit('setData', res.data.data);
          if(res.data.length) {
            commit('setTissue', true);
          } else {
            commit('setTissue', false);
          }
        }
        });
      }

    }
//=================================================================================
  },
  getters: {
    data (state) {
      return state.data;
    },
    filters (state) {
      return state.filters;
    },
    haveTests (state) {
      return {
        water: state.haveWaterTests,
        tissue: state.haveTissueTests,
        soil: state.haveSoilTests,
        media: state.haveMediaAnalysis,
      }
    },
    menu (state, getters, rootState, rootGetters) {
      let menu = [
        { key: 'soil-anal', label: app.$ml.get(`SOIL`) },
        { key: 'water-anal', label: app.$ml.get(`WATER`) },
        { key: 'tissue-anal', label: app.$ml.get(`TISSUE`) },
        { key: 'media-anal', label: app.$ml.get(`Media`) }
      ];

      // if(rootGetters['user/data'].globalRole == 'admin') menu.push({ key: 'media-anal', label: app.$ml.get(`Media`) });


      
      // if (state.haveSoilTests) { menu.push({ key: 'soil-anal', label: app.$ml.get(`SOIL`) }) }
      // if (state.haveWaterTests) { menu.push({ key: 'water-anal', label: app.$ml.get(`WATER`) }) }
      // if (state.haveTissueTests) { menu.push({ key: 'tissue-anal', label: app.$ml.get(`TISSUE`) }) }
      return menu;
    },
  }
};
